var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"wrapper"}},[_vm._l((_vm.columns.data),function(column){return _c('Column',{attrs:{"column":column},on:{"columnDestroy":function($event){return _vm.columnDestroy()}}})}),_vm._v(" "),_c('Modal',{on:{"closedModal":_vm.closedModal}}),_vm._v(" "),_c('button',{staticClass:"btn",on:{"click":function($event){return _vm.openModal()}}},[_vm._v(" Add column + ")])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d01bcdd8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 374
// module chunks = 0